<ng-container *ngIf="categories && deviations; else spinner">
    <p class="h3 text-center">Categories</p>

    <div class="chart d-flex justify-content-center">
        <canvas baseChart
                [datasets]="categoryChartDatasets"
                [type]="'pie'"
                [options]="categoryChartOptions"
                [labels]="categoryChartLabels"
                [legend]="categoryChartLegend"
                [plugins]="categoryChartPlugins"
                (chartClick)="chartClicked($event, 'category')">
        </canvas>
    </div>

    <p class="h3 text-center">Deviations</p>

    <div class="chart d-flex justify-content-center">
        <canvas baseChart width="750" height="300"
                [datasets]="deviationChartDatasets"
                [type]="'bar'"
                [options]="deviationChartOptions"
                [labels]="deviationChartLabels"
                [legend]="deviationChartLegend"
                [plugins]="deviationChartPlugins"
                (chartClick)="chartClicked($event, 'deviation')">
        </canvas>
    </div>
</ng-container>

<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
